import React from 'react'

import CreatorDiskIcon from '../assets/icons/signup/creator-disk.svg'
import ProDiskIcon from '../assets/icons/signup/pro-disk.svg'
import { FrontendSubscriptionPlan, FrontendUser, FrontendUserDetailed } from './types'

type TUser = FrontendUser | FrontendUserDetailed | null | undefined

const subscriptionPlanRatings: { [key: string]: number } = {
  creator_monthly: 1,
  pro_monthly: 2,
  //
  creator_yearly: 11,
  pro_yearly: 12,
}
const subscriptionPlanRatingValues = Object.values(subscriptionPlanRatings)
const subscriptionPlanMaxRatingValue = Math.max(...subscriptionPlanRatingValues)

export const checkIfUserSubscriptionIsFree = (currentUser: TUser) => {
  return !!currentUser && currentUser.subscriptionPlan === 'free'
}
export const checkIfUserSubscriptionCanBeUpgraded = (currentUser: TUser) => {
  return !!currentUser && subscriptionPlanRatings[currentUser.subscriptionPlan] < subscriptionPlanMaxRatingValue
}
export const checkIfUserSubscriptionIsMaximum = (currentUser: TUser) => {
  return !!currentUser && subscriptionPlanRatings[currentUser.subscriptionPlan] === subscriptionPlanMaxRatingValue
}

export const getPlanRatingValue = (planKey: string) => {
  return subscriptionPlanRatings[planKey] || 0
}

export const getDiskForUserSubscription = (subscriptionPlan: FrontendSubscriptionPlan, className?: string) => {
  const isPremium = subscriptionPlan !== 'free'

  const isCreator = isPremium && subscriptionPlan.includes('creator_')
  const isPro = isPremium && subscriptionPlan.includes('pro_')

  if (isCreator) return <CreatorDiskIcon className={className} />
  if (isPro) return <ProDiskIcon className={className} />
  return <></>
}
